export default __webpack_public_path__ + "static/hero-overlay-7a5ce02bbfaaaf7089b04cccb33b3343.png";